export default "__VITE_ASSET__4CkgOo8S__"